import { ErrorResponse, SupplierTypeEnum } from '@gtpl/shared-models/common-models';
import { SupplierResponseModel } from '@gtpl/shared-models/masters';
import { CommonResponse } from '@gtpl/shared-models/production-management';
import { LogsService } from '@gtpl/shared-services/user-logs';
import { Injectable } from '@nestjs/common';
import { InjectRepository } from '@nestjs/typeorm';
import appSettings from 'apps/services/config';
import { LogsDto } from 'libs/shared-models/user-logs/src/lib/Logs/logs.dto';
import { getManager, In, Raw, Repository } from 'typeorm';
import { TrimsConfigurationDto } from './dto/trims-configuration-dto';
import { TrimItemIdReq, TrimsItemRequest, TrimsRequset } from './dto/trims-req';
import { TrimsMapping } from './trims-configuration.entity';
@Injectable()
export class TrimsMappingService {
    constructor(
        private logService: LogsService,

        @InjectRepository(TrimsMapping) private trimsRepo: Repository<TrimsMapping>,
        // private supplierAdadpter : SuppliersAdapter,

    ) { }
    async getTrimsData(trimsReq: TrimsRequset): Promise<CommonResponse> {
        const manager = getManager();
        try {
            console.log('trimsReqlll')
            console.log(trimsReq)
            let trimsWIthAllConfigQry = `SELECT tmi.item_id as itemId,tmi.sub_category_id as subcategoryId,against_to as AgainstTo,number_of_trims as numberOfTrims FROM ` + appSettings.masters_db + `.trims_mapping tm
            left join `+ appSettings.masters_db + `.trim_items_mapping tmi on tmi.trim_id = tm.trim_id
            WHERE brand_id = ${trimsReq.brandId} AND (
                (end_customer_id = ${trimsReq.endCustomerId} AND variant_id = ${trimsReq.variantId} AND pack_style_id = ${trimsReq.packStyleId})
                OR (end_customer_id = 0 AND variant_id = 0 AND pack_style_id = 0)
                OR (end_customer_id = 0 AND variant_id = ${trimsReq.variantId} AND pack_style_id = ${trimsReq.packStyleId})
                OR (end_customer_id = 0 AND variant_id = 0 AND pack_style_id = ${trimsReq.packStyleId})
                OR (end_customer_id = 0 AND variant_id = ${trimsReq.variantId} AND pack_style_id = 0)
                OR (end_customer_id = ${trimsReq.endCustomerId} AND variant_id = 0 AND pack_style_id = ${trimsReq.packStyleId})
                OR (end_customer_id = ${trimsReq.endCustomerId} AND variant_id = 0 AND pack_style_id = 0)
                OR (end_customer_id = ${trimsReq.endCustomerId} AND variant_id = ${trimsReq.variantId} AND pack_style_id = 0) 
                )`;
            if (trimsReq.reqFrom == 'Preperation') {
                let againstTo = ''
                if (trimsReq.subcategoryId == 2) {
                    againstTo = 'Pouch'
                }
                if (trimsReq.subcategoryId == 3) {
                    againstTo = 'Carton'
                }
                if (trimsReq.subcategoryId == 4) {
                    againstTo = 'Ring'
                }
                if (trimsReq.subcategoryId == 5) {
                    againstTo = 'Skewer'
                }
                trimsWIthAllConfigQry += ` and tmi.item_id in (${trimsReq.itemId}) and tmi.against_to = '${againstTo}'`;
            }
            const trimsWIthAllConfig = await manager.query(trimsWIthAllConfigQry)
            if (trimsWIthAllConfig.length > 0) {
                return new CommonResponse(true, 9999, 'data retrived', trimsWIthAllConfig)

            } else {
                return new CommonResponse(false, 5555, 'No data', undefined)
            }

            // const trimsWIthAllConfig = await this.trimsRepo.findOne({
            //     relations: ["trimItemsInfo"],
            //     where: { brandId: trimsReq.brandId, variantId: trimsReq.variantId, packStyleId: trimsReq.packStyleId,endCustomerId:trimsReq.endCustomerId},
            // }
            // );
            // if (!trimsWIthAllConfig) {
            //     const trimsWIthVarientConfig = await this.trimsRepo.findOne({
            //         relations: ["trimItemsInfo"],
            //         where: { brandId: trimsReq.brandId, variantId: trimsReq.variantId, packStyleId: 0 },
            //     }
            //     );
            //     if (!trimsWIthVarientConfig) {
            //         const trimsWIthPackstyleConfig = await this.trimsRepo.findOne({
            //             relations: ["trimItemsInfo"],
            //             where: { brandId: trimsReq.brandId, variantId: 0, packStyleId: trimsReq.packStyleId },
            //         }
            //         );
            //         if (!trimsWIthPackstyleConfig) {
            //             const trimsWIthBrandConfig = await this.trimsRepo.findOne({
            //                 relations: ["trimItemsInfo"],
            //                 where: { brandId: trimsReq.brandId, variantId: 0, packStyleId: 0 },
            //             }
            //             );
            //             if (!trimsWIthBrandConfig) {
            //                 return new CommonResponse(false, 5555, 'No trims found')
            //             } else {
            //                 return new CommonResponse(true, 5555, 'data retreived', trimsWIthBrandConfig)
            //             }
            //         } else {
            //             return new CommonResponse(true, 5555, 'data retreived', trimsWIthPackstyleConfig)
            //         }

            //     } else {
            //         return new CommonResponse(true, 5555, 'data retreived', trimsWIthVarientConfig)
            //     }
            // } else {
            //     console.log('trimsWIthAllConfig')
            //     console.log((trimsWIthAllConfig.trimItemsInfo)[0])
            //     return new CommonResponse(true, 5555, 'data retreivedsss', trimsWIthAllConfig.trimItemsInfo)
            // }
            // // const trimsWIthAllConfig = await this.trimsRepo.find({where:{brandId:trimsReq.brandId,variantId:trimsReq.variantId,packStyleId:trimsReq.packStyleId},relations:["trimItemsInfo"]})
            // console.log('trimsWIthAllConfigQry')
            // console.log(trimsWIthAllConfig)

        } catch (err) {

        }
        return
    }
    async getalltrimsmappingdetails(): Promise<CommonResponse> {
        const manager = getManager();
        const query = '  SELECT e.end_customer_name AS endCustomerName,trim_id as trimId,brand_name AS brandName,packing_method_name AS packmethodName,variant_code AS variantCode,tm.is_active as isActive,tm.created_at,tm.created_user,tm.updated_at,tm.updated_user,tm.version_flag  FROM ' + appSettings.masters_db + '.trims_mapping tm  LEFT JOIN ' + appSettings.masters_db + '.master_brands b ON b.master_brand_id=tm.brand_id LEFT JOIN ' + appSettings.masters_db + '.sku_codes sk ON sk.sku_code_id=tm.variant_id LEFT JOIN ' + appSettings.masters_db + '.packing_methods pk ON pk.packing_method_id=tm.pack_style_id  LEFT JOIN ' + appSettings.masters_db + '.end_customers e ON tm.end_customer_id=e.end_customer_id ORDER BY e.end_customer_name ASC ';
        const result = await manager.query(query)
        if (result) {
            const response = new CommonResponse(true, 1111, "Data retrieved Sucessfully", result)
            const newLogDto = new LogsDto(1, 'view', 'TrimsMapping', 0, true, '', '')
            let res = await this.logService.createLog(newLogDto);
            return response
            console.log(res);
        } else {
            return new CommonResponse(false, 1111, "Error Occured")
        }

    }
    async getalltrimsitemmappingdetailsByTrimsId(req: TrimsItemRequest): Promise<CommonResponse> {
        const manager = getManager();
        const query = '  SELECT trim_item_id AS trimItemId,sub_category_id AS subcategoryId,ti.item_id AS itemId,trim_id AS trimId,item_sub_category AS itemsubCategory,item_name AS itemName,trim_name AS trimName,number_of_trims AS noOfTrims,ti.is_active,against_to as againstTo,item_sub_category as subCategory FROM`trim_items_mapping` ti LEFT JOIN `trims` t ON t.trimsid=ti.trim_id LEFT JOIN `item_sub_categories` sc ON sc.item_sub_category_id=ti.sub_category_id LEFT JOIN `items` i ON i.item_id=ti.item_id WHERE trim_id=' + req.trimId + '';
        const result = await manager.query(query)
        if (result) {
            return new CommonResponse(true, 1111, "Data retrieved Sucessfully", result)
        } else {
            return new CommonResponse(false, 1111, "Error Occure")
        }

    }

    async saveTrimsConfiguration(values: TrimsConfigurationDto): Promise<CommonResponse> {
        const req = new TrimsRequset()
        req.brandId = values.brandId
        req.packStyleId = values.packStyleId;
        req.variantId = values.variantId;
        req.endCustomerId = values.endCustomerId;
        if (values.trimId) {
            req.trimId = values.trimId;
            values.updatedUser = values.createdUser;
        }
        if(!values.trimId){
            const validation = await this.validateTrimsConfiguration(req, values.trimId ? true : false)
            if (!validation.status) return new CommonResponse(false, 2222, validation.internalMessage) 
        }
        const saveData = await this.trimsRepo.save(values)
        if (saveData) return new CommonResponse(true, 2222, values.trimId ? 'Trims Configuration Update' : 'Trims Configuration Created')
        return new CommonResponse(false, 2222, 'Error while creating Trims configuration ')
    }

    async validateTrimsConfiguration(req: TrimsRequset, isUpdate: boolean) {

        let finForDuplicate: TrimsMapping
        /* ----------------- */
        if (req.variantId == 0 && req.packStyleId == 0 && req.endCustomerId == 0) {
            finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record already exists with selected combination')
        }
        if (req.variantId == 0 && req.packStyleId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, endCustomerId: In([req.endCustomerId, 0]) } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record already exists with selected combination')
        }
        else if (req.endCustomerId == 0 && req.packStyleId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, variantId: In([req.variantId, 0]) } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record already exists with selected combination')
        }
        else if (req.endCustomerId == 0 && req.variantId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, packStyleId: In([req.packStyleId, 0]), } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record already exists with selected combination')
        }
        /* ------------------- */
        else if (req.packStyleId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, variantId: In([req.variantId]), endCustomerId: In([req.endCustomerId]) } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record with ALL PACK STYLES exists with selected attributes')
        }
        else if (req.variantId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, packStyleId: In([req.packStyleId]), endCustomerId: In([req.endCustomerId]) } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record with ALL PRODUCTS exists with selected attributes');
        }
        else if (req.endCustomerId == 0) {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, endCustomerId: 0, packStyleId: In([req.packStyleId]), variantId: In([req.variantId]) } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record with ALL ENDCUSTOMERS exists with selected attributes');
        } else {
            const finForDuplicate = await this.trimsRepo.findOne({ where: { brandId: req.brandId, packStyleId: req.packStyleId, variantId: req.variantId, endCustomerId: req.endCustomerId } })
            if (finForDuplicate) return new CommonResponse(false, 99999, 'A record with selected combination already exists');
        }
        if (isUpdate && finForDuplicate) {
            if (finForDuplicate.trimId != req.trimId) {
                return new CommonResponse(false, 1111, 'A record already exists')
            }
        } else if (finForDuplicate) {
            return new CommonResponse(false, 1111, 'A record already exists')
        }
        return new CommonResponse(true, 99999, 'Validated')

    }

    async validateTrimItems(req:any):Promise<CommonResponse>{

        return new CommonResponse(true,1111,'Validated')
    }

    async getAllTrimsDataForTrimId(req: TrimsItemRequest): Promise<CommonResponse> {
        const trimsConfigurationData = await this.trimsRepo.findOne({ where: { trimId: req.trimId } })
        const trimsItemsData = await this.getalltrimsitemmappingdetailsByTrimsId(req)
        const allData = { ...trimsConfigurationData, ...{ trimItemsInfo: trimsItemsData.data } }
        if (trimsConfigurationData && trimsItemsData.status) {
            return new CommonResponse(true, 11111, 'Data retreived sucessfully', allData)
        } else {
            return new CommonResponse(false, 11111, 'No data found')
        }
    }




}